import React, { FC, useEffect } from 'react'
import TopBanner from '../../components/TopBanner/TopBanner'
import Breadcrumbs from '../../components/Breadcrumbs/Breadcrumbs'
import { NavLink } from 'react-router-dom'
import s from './Project.module.scss'
import CardProject from '../../components/CardProject/CardProject'
import { useAppDispatch, useAppSelector } from '../../store/hooks'
import { fetchByProjects } from '../../store/slices/projectSlice'
import { scrollToTop } from '../../utils'
import Loader from '../../components/Loader/Loader'
import { Helmet } from 'react-helmet-async'

const Projects: FC = () => {
    const { projects, loading } = useAppSelector(state => state.projects)
    const dispatch = useAppDispatch()
    
    useEffect(() => {
        scrollToTop()
        dispatch(fetchByProjects())
    }, [dispatch])

    return (
        <>
        <Helmet>
            <title>
                Проекты | Phoenix Programs
            </title>

            <meta
                name="description"
                content="Реализованные проекты Phoenix Programs в сфере автоматизации технологических процессов, разработки ПЛК и SCADA-систем. Примеры внедрений и инженерных решений."
            />

            <link rel="canonical" href="https://phoenix-programs.ru/projects" />

            {/* Open Graph */}
            <meta property="og:type" content="website" />
            <meta property="og:locale" content="ru_RU" />
            <meta property="og:url" content="https://phoenix-programs.ru/projects" />
            <meta
                property="og:title"
                content="Проекты по автоматизации | Phoenix Programs"
            />
            <meta
                property="og:description"
                content="Примеры реализованных проектов в сфере промышленной автоматизации и разработки ПО."
            />
            <meta
                property="og:image"
                content="https://phoenix-programs.ru/logo192.png"
            />

            {/* Twitter */}
            <meta name="twitter:card" content="summary_large_image" />
            <meta
                name="twitter:title"
                content="Проекты Phoenix Programs"
            />
            <meta
                name="twitter:description"
                content="Реализованные проекты по автоматизации, ПЛК и SCADA."
            />
            <meta
                name="twitter:image"
                content="https://phoenix-programs.ru/logo192.png"
            />

            <meta name="robots" content="index, follow" />
        </Helmet>

            {loading && <Loader />}
            <TopBanner title='Проекты' />
            <Breadcrumbs>
                <NavLink to={'/'}>Главная</NavLink>
                /
                <NavLink to={`/projects`}>Проекты</NavLink>
            </Breadcrumbs>
            <section>
                <div className={`${s.wrapper} container`}>
                    {projects?.map((el) => (
                        <CardProject key={el.id} data={el} />
                    ))}
                </div>
            </section>
        </>
    )
}

export default Projects
